import { render, staticRenderFns } from "./giftcards-types.vue?vue&type=template&id=0b4d7199&scoped=true&"
import script from "./giftcards-types.vue?vue&type=script&lang=js&"
export * from "./giftcards-types.vue?vue&type=script&lang=js&"
import style0 from "./giftcards-types.vue?vue&type=style&index=0&id=0b4d7199&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d7199",
  null
  
)

export default component.exports